import React from 'react'
import classNames from 'classnames'

import style from './ConsentBadge.module.css'

export default function ConsentBadge({ children, className, consentType }) {
  return (
    <span className={classNames(style[consentType + 'Badge'], className)}>
      {children}
    </span>
  )
}
